export const BRAND_TABLE_TEXT_COLOR = "#021d53";
